module.exports = __webpack_public_path__ + "img/unpublished.26605589.png";